import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface ICheckRegisterDownloadStubsMissingDialogProps {
    dialogName: string;
    hideDialog: () => void;
    label?: string;
    heading?: string;
    // Only shown when at least one selected check does have a saved stub - if none do, there's
    // nothing to "proceed" with, so this collapses to a plain warning with just a Close button
    // (mirrors NoSelectedInvoicesWarningDialog for that case, ConfirmGenerateInvoiceDocumentsDialog's
    // Proceed/Cancel pair otherwise).
    canProceed?: boolean;
    onProceed?: () => void;
}

const CheckRegisterDownloadStubsMissingDialog = (props: ICheckRegisterDownloadStubsMissingDialogProps) => {

    return (
        <Dialog title={props?.heading ? props?.heading : ''} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '20%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ⚠️
                    <label>{!!props?.label ? props?.label : ``}</label>
                </form>
            </div>
            <div className="form-row" style={{ marginTop: '2rem', justifyContent: 'center' }}>
                {props.canProceed && (
                    <Button
                        className="blue-hover-button"
                        style={{ width: '30%', marginRight: '1rem' }}
                        text={'Proceed anyway?'}
                        onClick={() => props.onProceed && props.onProceed()}
                    />
                )}
                <Button
                    className="blue-hover-button"
                    style={{ width: props.canProceed ? '20%' : '24%', marginRight: '1rem' }}
                    text={props.canProceed ? 'Cancel' : 'Close'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default CheckRegisterDownloadStubsMissingDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/checkRegister/CheckRegisterDownloadStubsMissingDialog.tsx